
export const sFechaPublicacion = '2026-11-04T16:35:43.3087712-06:00';
export const sVersion = 'vf1.1.611041635';
            